import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import logo from "./logo.svg";
import "./App.css";
import { sendFeedback } from "./feedback_form_controller";

const FeedbackForm = () => {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [formStatus, setFormStatus] = useState("");
  const [alertVisible, setAlertVisible] = useState(false);
  const [loading, setLoading] = useState(false); // 新增 loading 狀態

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !email || !message) {
      setFormStatus("all_fields_required");
      return;
    }

    setLoading(true); // 開始 loading 狀態

    try {
      let response = await sendFeedback(name, email, message);
      if (response.status === 204) {
      } else if (response.status === 200) {
        setFormStatus("feedback_submit_success");
        setAlertVisible(true);
        setName("");
        setEmail("");
        setMessage("");
      } else {
        setFormStatus("feedback_submit_failed");
        setAlertVisible(true);
      }
    } catch (error) {
      setFormStatus("feedback_submit_error");
      setAlertVisible(true);
    } finally {
      setLoading(false); // 結束 loading 狀態
    }
  };

  const closeAlert = () => {
    setAlertVisible(false);
  };

  return (
    <div className="container">
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <img src={logo} className="App-logo" alt="logo" />
      </div>
      <h2 className="main-font-color">
        {t("feedback_and_issue_reporting_form")}
      </h2>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          padding: "20px",
        }}
      >
        <div className="column">
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder={t("name_placeholder")}
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
            <input
              type="email"
              placeholder={t("account_placeholder")}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <div className="main-font-color" style={{ textAlign: "left" }}>
              {t("question_detail")}
            </div>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            />
            <button
              className="primary_button medium_gap_top"
              type="submit"
              disabled={loading}
            >
              {loading ? t("processing") : t("submit")}
            </button>
          </form>
        </div>
      </div>
      {alertVisible && (
        <div className="alert-overlay" onClick={closeAlert}>
          <div className="alert-content" onClick={(e) => e.stopPropagation()}>
            <p>{t(formStatus)}</p>
            <button className="primary_button" onClick={closeAlert}>
              {t("close")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FeedbackForm;
